import { lineHeight, padding } from "@mui/system";
import { color } from "highcharts";

export const commonCss = {
  quickTextUl: {
    paddingTop: 0,
    paddingBottom: 0,
    color: "gray",
    fontSize: "14px",
    paddingLeft: "0px",
  },
  routerLinkText: {
    display: "flex",
    color: "gray",
    textDecoration: "none",
    padding: "0px 0px 0px 8px",
    "&:hover": {
      color: "#007BFF",
      textDecoration: "underline",
    },
  },
};

export const radioLabel = {
  label: {
    ".MuiTypography-root": {
      fontSize: "13px", // Ensure this targets the inner Typography
      lineHeight: "16px",
    },
    color: "#5d586c",
    fontWeight: 400,
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },

  additionLabel: {
    // ".MuiTypography-root": {
    fontSize: "13px", // Ensure this targets the inner Typography
    lineHeight: "16px",
    // },
    color: "#5d586c",
    fontWeight: 400,
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },

  labelDark: {
    // ".MuiTypography-root": {
    fontSize: "14px", // Ensure this targets the inner Typography
    lineHeight: "14px",
    fontWeight: 700,
    // },
    color: "#6f6b7d",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
  labelDarkMobile: {
    fontSize: "12px", // Ensure this targets the inner Typography
    lineHeight: "14px",
    fontWeight: 700,
    color: "#6f6b7d",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
};

export const summaryActionButtonStyles = {
  save: {
    minWidth: 92,
    height: 36,
    px: 2,
    py: 0,
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "6px",
    fontFamily: "Jost, sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.43px",
    textTransform: "none",
    color: "#fff",
    backgroundColor: "#00b3b5",
    boxShadow: "0px 2px 4px rgba(165, 163, 174, 0.3)",
    "&:hover": {
      backgroundColor: "#00999A",
      color: "#fff",
      boxShadow: "0px 2px 4px rgba(165, 163, 174, 0.3)",
    },
    "&.Mui-disabled": {
      backgroundColor: "#E6E6E6",
      color: "#B3B3B3",
      boxShadow: "none",
    },
  },
  cancel: {
    minWidth: 92,
    height: 36,
    px: 2,
    py: 0,
    borderRadius: "6px",
    fontFamily: "Jost, sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.43px",
    textTransform: "none",
    color: "#00b3b5",
    border: "1px solid #00b3b5",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "rgba(0, 179, 181, 0.06)",
      border: "1px solid #00b3b5",
      color: "#00b3b5",
    },
    "&.Mui-disabled": {
      borderColor: "#D9E9E9",
      color: "#93B7B8",
    },
  },
  textAction: {
    px: 0,
    py: 0,
    minWidth: "auto",
    display: "inline-flex",
    alignItems: "center",
    fontFamily: "Jost, sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.43px",
    color: "#00b3b5",
    textTransform: "none",
    "& .MuiButton-startIcon": {
      marginRight: "6px",
      marginLeft: 0,
      color: "#00b3b5",
      lineHeight: "16px",
      display: "inline-flex",
      alignItems: "center",
    },
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "none",
      color: "#00b3b5",
    },
  },
};
